import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'durationStringToMinutes',
})
export class DurationStringToMinutesPipe implements PipeTransform {
  transform(durationString: string): number {
    const parts = durationString.split(':');
    const hours = parts[0];
    const minutes = parts[1];
    return Number(hours) * 60 + Number(minutes);
  }
}
